/**
 * HexaIcon component for SpeedDial
 * Displays a hexagonal icon with temperature symbol
 */
import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectCurrentEntity } from '../../store/slices/navigationSlice';
import { formatDomain } from '../../utils/entityHelpers';
import DomainShape from '../DomainShape';

/**
 * Hexagonal icon with temperature symbol
 * @returns {JSX.Element} HexaIcon component
 */
const HexaIcon = () => {
  const entity = useSelector(selectCurrentEntity);
  const domainKey = formatDomain(entity?.domaine);

  return (
    <>
      <DomainShape
        domain={domainKey}
        bgProps={{ fill: 'white' }}
        pathProps={{ stroke: 'currentcolor', strokeWidth: 2.2, inset: 0 }}
      />
      <Box
        sx={{
          position: 'absolute',
          left: '40%',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        °C
      </Box>
    </>
  );
};

HexaIcon.displayName = 'HexaIcon';

export default HexaIcon;